import styles from "./styles.module.scss";
import vika_img from "../../images/vika.png";
import exclamation_img from "../../images/exclamation.png";
import Section from "../../components/Section";

import git_icon from "../../graphics/git_icon.svg";
import behance_icon from "../../graphics/behance_icon.svg";
import mail_icon from "../../graphics/mail_icon.svg";
import tg_icon from "../../graphics/tg_icon.svg";

const About = () => {
  return (
    <Section color="#1D1D1D">
      <div className={styles.container}>
        <div className={styles.img}>
          <img src={vika_img} alt="person" />
        </div>

        <div className={styles.description}>
          <div className={styles.section}>
            <h1 className={styles.secondary}>
              ПРИВЕТ
              <span>
                <img src={exclamation_img} alt="" />
              </span>
            </h1>
            <p className={styles.text} style={{ maxWidth: "450px" }}>
              Меня зовут Вика, я веб-дизайнер. Для меня дизайн должен быть не
              только визуально приятным и аутентичным, но и логичным. В работе
              выделяю уникальные черты бизнеса.
            </p>
          </div>

          <div className={styles.section}>
            <h4 className={styles.subtitle}>Образование</h4>
            <div className={styles.date}>
              <p className={styles.secondary}>2017-2022</p>
              <p className={styles.text}>
                Казанский Государственный Архитектурно-Строительный Университет
              </p>
            </div>
          </div>

          <div className={styles.double}>
            <div className={styles.section}>
              <h4 className={styles.subtitle}>Опыт работы</h4>
              <p className={styles.secondary}>2 года</p>
            </div>
            <div
              className={styles.section}
              style={{ justifyContent: "space-between" }}
            >
              <h4 className={styles.subtitle}>Знание языков</h4>
              <div className={styles.languages}>
                <p className={styles.text}>Английский - В2</p>
                <p className={styles.text}>Итальянский - В1</p>
              </div>
            </div>
          </div>

          <div className={styles.socials}>
            <div className={styles.item}>
              <div>
                <img src={git_icon} alt="" />
              </div>
              <a
                target="_blank"
                href="https://github.com/leiderovaviktoriia"
                className={styles.text}
              >
                leiderovaviktoriia
              </a>
            </div>
            <div className={styles.item}>
              <div>
                <img src={behance_icon} alt="" />
              </div>
              <a
                href="https://www.behance.net/viktorileidero1"
                target="_blank"
                className={styles.text}
              >
                Viktoriia Leiderova
              </a>
            </div>
            <div className={styles.item}>
              <div>
                <img src={mail_icon} alt="" />
              </div>
              <a
                href="mailto:viktoriia.leiderova@gmail.com"
                className={styles.text}
              >
                viktoriia.leiderova@gmail.com
              </a>
            </div>
            <div className={styles.item}>
              <div>
                <img src={tg_icon} alt="" />
              </div>
              <a
                target="_blank"
                href="https://t.me/viktoriialei"
                className={styles.text}
              >
                viktoriialei
              </a>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default About;
